import { Component } from '@angular/core';

@Component({
  selector: 'app-wedding-layout',
  templateUrl: './wedding-layout.component.html',
  styleUrls: ['./wedding-layout.component.scss']
})
export class WeddingLayoutComponent {

}
